export default __webpack_public_path__ + "dac08025bda75843ac6764f134897a71.svg";